import React, { useEffect, useState } from 'react';
import ZoomInIcon from '@atlaskit/icon/glyph/media-services/zoom-in';
import ZoomOutIcon from '@atlaskit/icon/glyph/media-services/zoom-out';
import { token } from '@atlaskit/tokens';
import { injectIntl } from '@atlassian/jira-intl';
import Button from '@atlassian/jira-portfolio-3-common/src/button/index.tsx';
import messages from './messages.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

const formatZoom = (zoom: number): string => `${(zoom * 100).toFixed(0)}%`;

const iconBtnStyle = {
	padding: `${token('space.050', '4px')} ${token(
		'space.050',
		'4px',
	)} ${token('space.025', '2px')} ${token('space.050', '4px')}`,
} as const;

export function ZoomBar({
	intl,
	onZoomIn,
	onZoomOut,
	onReset,
	onFit,
	onMount,
	initialScale = 1,
}: Props) {
	const [zoom, setZoom] = useState<number>(initialScale);

	// Give the parent access to the setZoom function
	useEffect(() => {
		onMount(setZoom);
	}, [onMount]);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.container}>
			<Button
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={iconBtnStyle}
				appearance="subtle"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.akIconButton}
				onClick={onZoomOut}
				spacing="none"
				testId="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.zoom-out"
			>
				<ZoomOutIcon size="medium" label={intl.formatMessage(messages.zoomOut)} />
			</Button>
			<Button
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={iconBtnStyle}
				appearance="subtle"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.akIconButton}
				onClick={onZoomIn}
				spacing="none"
				testId="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.zoom-in"
			>
				<ZoomInIcon size="medium" label={intl.formatMessage(messages.zoomIn)} />
			</Button>
			<span
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.zoomLevel}
				data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.percentage"
				aria-live="polite"
				aria-atomic="true"
			>
				{formatZoom(zoom)}
			</span>

			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<Button className={styles.button} onClick={onFit}>
				{intl.formatMessage(messages.fitButton)}
			</Button>
			<Button
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.button}
				onClick={onReset}
				testId="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.reset"
			>
				{intl.formatMessage(messages.resetButton)}
			</Button>
		</div>
	);
}

export default injectIntl(ZoomBar);
